export const educationData = [
    {
        id: 1,
        institution: 'Masai School',
        course: 'Full Stack Web Devloper',
        startYear: '2021',
        endYear: '2022'
    },
    {
        id: 2,
        institution: 'Gandhi Eng. College, Bhubaneswar',
        course: `Bachlore's in Computer Science`,
        startYear: '2016',
        endYear: '2020'
    },
    {
        id: 3,
        institution: 'Kolhan Inter College, Chaliyama',
        course: 'intermediate',
        startYear: '2013',
        endYear: '2016'
    }
]